<template>
    <div class="post-detail-container">
        <div class="title">{{postDetail.title}}</div>
        <div class="post-detail" v-html="postDetail.content"></div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                postId:this.$route.params.id,
                postDetail:{}
            }
        },
        mounted(){
            this.getPostDetail()    
        },
        methods:{
            async getPostDetail(){
                try {
                    const res = await this.$api.getPostDetail({id:this.postId})
                    console.log(res)
                    if(res.code==1){
                        this.postDetail = res.data.info
                    }else{
                        this.$message.error(res.msg||res.message)
                    }
                } catch (error) {
                    this.$message.error("获取帖子详情失败")
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.post-detail-container{
    padding: 30px;
    padding-top: 130px;
    .title{
        font-size: 24px;
        font-weight: 600;
        text-align: center;
    }
    .post-detail{
        width: 100%;
        img{
            max-width: 100%;
        }
    }
}
</style>